import request from '@/util/request';

/**
 * 获取人员架构数据
 * @returns {Promise} 返回一个包含人员架构数据的 Promise
 */
export function getStaffStructureTree(data) {
  return request({
    url: '/sidebar/staffStructure/tree',
    method: 'post',
    data
  });
}

/**
 * 获取品牌列表数据
 * @returns {Promise} 返回一个包含品牌列表数据的 Promise
 */
export function getBrandList(data) {
  return request({
    url: '/sidebar/brand/tree',
    method: 'post',
    data
  });
}
